const selectProps = <T>() => (_: unknown, props: T) => props;

export default selectProps;
